module.exports = __webpack_public_path__ + "media/images/photos/wheel-tire-5b6178bf254f85399f454ccf824a904a.jpg";